import posthtml from 'posthtml/lib';
export const hidePixel = mjml => {
  const addStyleTag = tree => {
    tree.match({
      tag: 'mj-head'
    }, node => {
      if (!node.content) {
        node.content = [];
      }
      node.content.push({
        tag: 'mj-style',
        content: ['.data-element-mj-body>img{position:absolute;}']
      });
      return node;
    });
  };
  const withHiddenPixel = posthtml([addStyleTag]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withHiddenPixel.html;
};
//# sourceMappingURL=hide-pixel.js.map